  <div class="setting-page">
    <legend>Syslogs</legend>

    <div class="action-buttons">
      <arm-action-bar
                      (editClick)="editItem()" [disableEdit]="!selection || isUnauthorized"></arm-action-bar>
    </div>

    <div class="settings-general-table">
      <arm-table [displayedColumns]="displayedColumns"
                 (onSelection)="onSelection($event)" [data]="items"
                 [isMultipleSelection]="false"
                 [isClientSide]="true" [isPagedTable]="false"></arm-table>
    </div>
  </div>
